/* eslint-disable */
/* this file is generated by generateIcons script */

// @ts-ignore
import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AccountTypeCustomerIcon extends BaseIcon {
    getChildren = () => [<>
        <circle cx="15.777" cy="15.777" r="15.777" fill="#f2f2f2"/>
        <g transform="translate(8.194 7.116)">
            <g>
                <path
                      d="M8,3.807a1.907,1.907,0,1,0-1.907-1.9A1.907,1.907,0,0,0,8,3.807Z"
                      transform="translate(-0.709 0.007)" fill="#2e3f58"/>
                <path
                      d="M8,4.573A3.42,3.42,0,0,0,4.573,7.907a.127.127,0,0,0,0,.087.133.133,0,0,0,.093.04h6.56a.167.167,0,0,0,.12-.053.16.16,0,0,0,.047-.12A3.433,3.433,0,0,0,8,4.573Z"
                      transform="translate(-0.709 0.007)" fill="#2e3f58"/>
                <path d="M7,6.562v3.589" transform="translate(0.291 3.733)"
                      fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                <path d="M0,4.066V0"
                      transform="translate(2.052 13.222) rotate(-150)" fill="none" stroke="#2e3f58"
                      strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                <path d="M1.5,0,3,2H0Z"
                      transform="matrix(-0.891, -0.454, 0.454, -0.891, 2.673, 15.456)" fill="#2e3f58" stroke="#2e3f58"
                      strokeLinejoin="round" strokeWidth="1"/>
                <g transform="translate(10.445 9.708)">
                    <path d="M0,0V4.057" transform="translate(0 0) rotate(-30)"
                          fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                    <path d="M1.5,0,3,2H0Z"
                          transform="matrix(-0.891, 0.454, -0.454, -0.891, 4.081, 4.386)" fill="#2e3f58"
                          stroke="#2e3f58" strokeLinejoin="round" strokeWidth="1"/>
                </g>
                <path d="M1.5,0,3,2H0Z"
                      transform="translate(8.789 15.884) rotate(180)" fill="#2e3f58" stroke="#2e3f58"
                      strokeLinejoin="round" strokeWidth="1"/>
            </g>
        </g>
    </>]
    getViewBox = () => '0 0 31.555 31.555'
}
